import { v4 as uuidv4 } from 'uuid';

export const randomUUID = () => uuidv4().toUpperCase();

export const i18nLanguageToLabel = (lng: string): string | undefined => {
  if (lng === 'es-419') return 'Spanish';
  if (lng === 'en') return 'English';
  return undefined;
};
